import React, { useState } from 'react';
import Form from './Form.js';

function Modal() {
  return (
    <>
    <div className="hystmodal order-popup" id="order-call" aria-hidden="true">
        <div className="hystmodal__wrap">
            <div className="hystmodal__window order-popup__window" role="dialog" aria-modal="true">
                <button data-hystclose className="hystmodal__close">Закрыть</button>
                <div className="order-popup__info">
                    <h2 className="order-popup__title title">Нужна помощь? <br/>
                        Закажите обратный звонок</h2>
                    <p className="order-popup__text text">
                        Наш менеджер свяжется с вами в ближайшее время
                    </p>
                </div>
                <Form 
                    title='Заполните форму'
                    className={'order-popup__form form form--vertical form--modal callback__form'}
                    button={'Отправить'}
                />
            </div>
        </div>
    </div>
    <div className="hystmodal policy-popup" id="policy" aria-hidden="true">
        <div className="hystmodal__wrap">
            <div className="hystmodal__window policy-popup__window" role="dialog" aria-modal="true">
                <button data-hystclose className="hystmodal__close">Закрыть</button>
                <div className="policy">
                    <h2 className="policy__title">Политика конфиденциальности</h2>
                    <h3 className="policy__subtitle">1. Общие положения</h3>
                    <p className="policy__text">
                        Настоящая политика обработки персональных данных составлена в
                        соответствии с требованиями Федерального закона от 27.07.2006. № 152-ФЗ
                        «О персональных данных» и определяет порядок обработки персональных
                        данных и меры по обеспечению безопасности персональных данных.
                    </p>
                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Оператор ставит своей важнейшей целью и условием осуществления
                            своей деятельности соблюдение прав и свобод человека и гражданина
                            при обработке его персональных данных, в том числе защиты прав на
                            неприкосновенность частной жизни, личную и семейную тайну.
                        </li>
                        <li className="policy__item">
                            2. Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика)
                            применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта компании
                            Topkids (ИП Швейкус Галина Валентиновна,
                            ИНН 280100993246).
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">
                        2. Основные понятия, используемые в Политике
                    </h3>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Автоматизированная обработка персональных данных — обработка
                            персональных данных с помощью средств вычислительной техники;
                        </li>
                        <li className="policy__item">
                            2. Блокирование персональных данных — временное прекращение
                            обработки персональных данных (за исключением случаев, если
                            обработка необходима для уточнения персональных данных);
                        </li>
                        <li className="policy__item">
                            3. Веб-сайт — совокупность графических и информационных материалов,
                            а также программ для ЭВМ и баз данных, обеспечивающих их доступность
                            в сети интернет по сетевому адресу
                        </li>
                        <li className="policy__item">
                            4. Информационная система персональных данных — совокупность
                            содержащихся в базах данных персональных данных, и обеспечивающих их
                            обработку информационных технологий и технических средств;
                        </li>
                        <li className="policy__item">
                            5. Обезличивание персональных данных — действия, в результате
                            которых невозможно определить без использования дополнительной
                            информации принадлежность персональных данных конкретному
                            Пользователю или иному субъекту персональных данных;
                        </li>
                        <li className="policy__item">
                            6. Обработка персональных данных — любое действие (операция) или
                            совокупность действий (операций), совершаемых с использованием
                            средств автоматизации или без использования таких средств с
                            персональными данными, включая сбор, запись, систематизацию,
                            накопление, хранение, уточнение (обновление, изменение), извлечение,
                            использование, передачу (распространение, предоставление, доступ),
                            обезличивание, блокирование, удаление, уничтожение персональных
                            данных;
                        </li>
                        <li className="policy__item">
                            7. Оператор — государственный орган, муниципальный орган,
                            юридическое или физическое лицо, самостоятельно или совместно с
                            другими лицами организующие и (или) осуществляющие обработку
                            персональных данных, а также определяющие цели обработки
                            персональных данных, состав персональных данных, подлежащих
                            обработке, действия (операции), совершаемые с персональными данными;
                        </li>
                        <li className="policy__item">
                            8. Персональные данные — любая информация, относящаяся прямо или
                            косвенно к определенному или определяемому Пользователю веб-сайта;
                        </li>
                        <li className="policy__item">
                            9. Пользователь — любой посетитель веб-сайта;
                        </li>
                        <li className="policy__item">
                            10. Предоставление персональных данных — действия, направленные на
                            раскрытие персональных данных определенному лицу или определенному
                            кругу лиц;
                        </li>
                        <li className="policy__item">
                            11. Распространение персональных данных — любые действия,
                            направленные на раскрытие персональных данных неопределенному кругу
                            лиц (передача персональных данных) или на ознакомление с
                            персональными данными неограниченного круга лиц, в том числе
                            обнародование персональных данных в средствах массовой информации,
                            размещение в информационно-телекоммуникационных сетях или
                            предоставление доступа к персональным данным каким-либо иным
                            способом;
                        </li>
                        <li className="policy__item">
                            12. Трансграничная передача персональных данных — передача
                            персональных данных на территорию иностранного государства органу
                            власти иностранного государства, иностранному физическому или
                            иностранному юридическому лицу;
                        </li>
                        <li className="policy__item">
                            13. Уничтожение персональных данных — любые действия, в результате
                            которых персональные данные уничтожаются безвозвратно с
                            невозможностью дальнейшего восстановления содержания персональных
                            данных в информационной системе персональных данных и (или)
                            результате которых уничтожаются материальные носители персональных
                            данных.
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">
                        3. Оператор может обрабатывать следующие персональные данные
                        Пользователя
                    </h3>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">1. Фамилия, имя, отчество;</li>
                        <li className="policy__item">2. Номер телефона;</li>
                        <li className="policy__item">3. Адрес электронной почты;</li>
                        <li className="policy__item">
                            4. Также на сайте происходит сбор и обработка обезличенных данных о
                            посетителях (в т. ч. файлов «cookie») с помощью сервисов
                            интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).
                        </li>
                        <li className="policy__item">
                            5. Вышеперечисленные данные далее по тексту Политики объединены
                            общим понятием Персональные данные.
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">
                        4. Цели обработки персональных данных
                    </h3>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Цель обработки персональных данных Пользователя — заключение,
                            исполнение и прекращение гражданско-правовых договоров;
                            предоставление доступа Пользователю к сервисам, информации и/или
                            материалам, содержащимся на веб-сайте; уточнение деталей обращения.
                        </li>
                        <li className="policy__item">
                            2. Также Оператор имеет право направлять Пользователю уведомления о
                            новых продуктах и услугах, специальных предложениях и различных
                            событиях. Пользователь всегда может отказаться от получения
                            информационных сообщений, направив Оператору письмо на адрес
                            электронной почты с доменом 545993@mail.ru с пометкой «Отказ от
                            уведомлений о новых продуктах и услугах и специальных предложениях».
                        </li>
                        <li className="policy__item">
                            3. Обезличенные данные Пользователей, собираемые с помощью сервисов
                            интернет-статистики, служат для сбора информации о действиях
                            Пользователей на сайте, улучшения качества сайта и его содержания.
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">
                        5. Правовые основания обработки персональных данных
                    </h3>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Оператор обрабатывает персональные данные Пользователя только в
                            случае их заполнения и/или отправки Пользователем самостоятельно
                            через специальные формы, расположенные на сайте. Заполняя
                            соответствующие формы и/или отправляя свои персональные данные
                            Оператору, Пользователь выражает свое согласие с данной Политикой.
                        </li>
                        <li className="policy__item">
                            2. Оператор обрабатывает обезличенные данные о Пользователе в
                            случае, если это разрешено в настройках браузера Пользователя
                            (включено сохранение файлов «cookie» и использование технологии
                            JavaScript).
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">
                        6. Порядок сбора, хранения, передачи и других видов обработки
                        персональных данных
                    </h3>

                    <p className="policy__text">
                        Безопасность персональных данных, которые обрабатываются Оператором,
                        обеспечивается путем реализации правовых, организационных и
                        технических мер, необходимых для выполнения в полном объеме требований
                        действующего законодательства в области защиты персональных данных.
                    </p>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Оператор обеспечивает сохранность персональных данных и принимает
                            все возможные меры, исключающие доступ к персональным данным
                            неуполномоченных лиц.
                        </li>
                        <li className="policy__item">
                            2. Персональные данные Пользователя никогда, ни при каких условиях
                            не будут переданы третьим лицам, за исключением случаев, связанных с
                            исполнением действующего законодательства.
                        </li>
                        <li className="policy__item">
                            3. Срок обработки персональных данных является неограниченным.
                            Пользователь может в любой момент отозвать свое согласие на
                            обработку персональных данных, направив Оператору уведомление
                            посредством электронной почты на электронный адрес Оператора с
                            пометкой «Отзыв согласия на обработку персональных данных».
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">
                        7. Трансграничная передача персональных данных
                    </h3>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Оператор до начала осуществления трансграничной передачи
                            персональных данных обязан убедиться в том, что иностранным
                            государством, на территорию которого предполагается осуществлять
                            передачу персональных данных, обеспечивается надежная защита прав
                            субъектов персональных данных.
                        </li>
                        <li className="policy__item">
                            2. Трансграничная передача персональных данных на территории
                            иностранных государств, не отвечающих вышеуказанным требованиям,
                            может осуществляться только в случае наличия согласия в письменной
                            форме субъекта персональных данных на трансграничную передачу его
                            персональных данных и/или исполнения договора, стороной которого
                            является субъект персональных данных.
                        </li>
                    </ul>

                    <h3 className="policy__subtitle">8. Заключительные положения</h3>

                    <ul className="policy__list list-reset">
                        <li className="policy__item">
                            1. Пользователь может получить любые разъяснения по интересующим
                            вопросам, касающимся обработки его персональных данных, обратившись
                            к Оператору по телефону, указанному на сайте.
                        </li>
                        <li className="policy__item">
                            2. В данном документе будут отражены любые изменения политики
                            обработки персональных данных Оператором. Политика действует
                            бессрочно до замены ее новой версией.
                        </li>
                        <li className="policy__item">
                            3. Актуальная версия Политики в свободном доступе расположена в сети
                            Интернет на сайте.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>          
              
    </>
  );
}

export default Modal;
